// react
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ImprintModal = (props) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Modal
        show={props.showModal}
        onHide={props.hideModal}
        size="lg"
        id="ItemEditModal"
        scrollable={true}
        dialogClassName="modal-dialog-centered"
      >
        <Modal.Header onHide={props.hideModal} closeButton>
          {t("Imprint")}
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              textAlign: "justify",
              marginLeft: "3em",
              marginRight: "3em",
            }}
          >
            <p>
              {"Line Up Handels GmbH"}
              <br />
              {"Tomphecke 42"}
              <br />
              {"41169 Mönchengladbach"}
              <br />
              {t("Germany")}
              <br />
              <br />
              {t("P +49 (0) 2161 95390 0")}
              <br />
              {"F +49 (0) 2161 95390 39"}
              <br />
              <br />
              {"www.lineup.de"}
              <br />
              {"info@lineup.de"}
              <br />
              <br />
              {"HRB 4490"}
              <br />
              {t("VAT number DE154056432")}
              <br />
              <br />
              {t("CEO: Jan P. Silanoglu, Max L. Silanoglu")}
              <br />
              <br />
            </p>
            <h2>{t("Disclaimer")}</h2>
            <br />
            <h3>{t("Content of the online offer")}</h3>
            <p>
              {t(
                "Line Up Handels GmbH makes every effort to provide correct and complete information on these Internet pages. All information has  been compiled to the best of our knowledge and carefully checked.  Nevertheless, Line Up Handels GmbH does not guarantee or assume  liability for the topicality, correctness and completeness of the  information provided. Line Up Handels GmbH reserves the right to  change or delete parts of the pages or the entire offer at any time  without prior notice."
              )}
            </p>
            <h3>{t("Links")}</h3>
            <p>
              {t(
                "Line Up Handels GmbH has no influence whatsoever on the authorship, design and content of linked pages. In spite of careful control of  the contents before setting a link, Line Up Handels GmbH does not  assume any liability for the contents of linked pages. The content of linked pages and any damage resulting from their use is the sole responsibility of their providers."
              )}
            </p>
            <h3>{t("Copyright")}</h3>
            <p>
              {t(
                "Copyright 2023 Line Up Handels GmbH. All rights reserved. All texts,  images and graphics as well as their arrangements are subject to  copyright and other laws for the protection of intellectual property. They may not be copied for commercial use or distribution,  nor may they be modified or used on other websites. The copyrights  of this website and all its contents are owned in full by Line Up Handels GmbH."
              )}
            </p>
            <h3>{t("Privacy policy")}</h3>
            <p>
              {t(
                "When using our forms, we need some data from you so that we can process the request correctly. Filling out this form and providing this data is voluntary. Line Up Handels GmbH will treat this information confidentially and use it only for its own needs."
              )}
            </p>
            <h3>{t("Legal validity")}</h3>
            <p>
              {t(
                "This disclaimer was created to the best of our knowledge. If  individual formulations should not, no longer or not completely correspond to the valid legal situation, the remaining parts remain unaffected in their content and validity."
              )}
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={props.hideModal}>
            {t("Close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default ImprintModal;
